export default __webpack_public_path__ + "static/media/service-img-4.1bce729d.png";